import { render, staticRenderFns } from "./MisRequerimientos.vue?vue&type=template&id=11e81c02&scoped=true"
import script from "./MisRequerimientos.vue?vue&type=script&lang=js"
export * from "./MisRequerimientos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e81c02",
  null
  
)

export default component.exports